import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, SidebarSkeleton } from './Sidebar';
import { FullPageLoader } from '../ui/Spinner';
export function AppShell() {
  const [booting, setBooting] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setBooting(false), 900);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-full w-full bg-white" data-id="element-76" data-mp="gmj5ov58r0rz">
      {booting ? <SidebarSkeleton data-id="element-77" data-mp="go3zujnn8hpb" /> : <Sidebar data-id="element-78" data-mp="ckectymma86e" />}
      <div className="flex min-h-screen flex-col pl-[147px]" data-id="element-79" data-mp="cjwack9d2xq1">
        {booting ? <FullPageLoader data-id="element-80" data-mp="cmsamf8olyhn" /> : <Outlet data-id="element-81" data-mp="7tfteq6c0tyx" />}
      </div>
    </div>;
}